import {defineStore} from "pinia";
import {ref} from 'vue'

/*登录Token*/
export const userTokenStore = defineStore(
    'userToken',
    () =>{
        const token = ref('')
        const setToken = (newToken) => {
            token.value = newToken
        }
        const removeToken = () => {
            token.value = ''
        }
        return {
            token,
            setToken,
            removeToken
        }
    },
    {
        persist: true
    }
)

/*用户信息*/
export const userInfoStore = defineStore(
    'userInfo',
    () => {
        const info = ref('')
        const setInfo = (newInfo) => {
            info.value = newInfo
        }
        const removeInfo = () => {
            info.value = ''
        }
        return {
            info,
            setInfo,
            removeInfo
        }
    },
    {
        persist: true
    }
)

/*菜单信息*/
export const menuStore = defineStore(
    'menu',
    () => {
        const menu = ref('')
        const setMenu = (newMenu) => {
            menu.value = newMenu
        }
        const removeMenu = () => {
            menu.value = ''
        }
        return {
            menu,
            setMenu,
            removeMenu
        }
    },
    {
        persist: true
    }
)
/*省市区信息*/
export const addressStore = defineStore(
    'address',
    () => {
        const address = ref('')
        const setAddress = (newAddress) => {
            address.value = newAddress
        }
        const removeAddress = () => {
            address.value = ''
        }
        return {
            address,
            setAddress,
            removeAddress
        }
    },
    {
        persist: true
    }
)
